<template>
    <div class="container">
        <div class="content-banner">
            <img src="@/assets/join/banner.png" alt="">
        </div>
        <div class="content-block-1">
            <!-- <div class="top-container">
                <ul ref="hzzc" class="top-card">
                    <li class="top-card-item">
                        <div>每月新开门店</div>
                        <div class="f-red f-wei">400+</div>
                    </li>
                    <li class="top-card-item">
                        <div>加盟商二店率</div>
                        <div class="f-red f-wei">{{ countObj.secondRate }}%</div>
                    </li>
                    <li class="top-card-item">
                        <div>开店成功率</div>
                        <div class="f-red f-wei">{{countObj.successRate}}%</div>
                    </li>
                </ul>
            </div> -->
            <div class="coop-content" style="display: flex;align-items: center;justify-content: center;margin-bottom: 30px;"><img src="@/assets/join/title_Cooperation.png" style="width: 650px;height: auto;" alt=""></div>
            <ul class="coop-list">
                <!-- <li class="coop-item" v-for="(item,index) in coopList" :key="index">
                    <div class="coop-item-content">
                        <div class="coop-item-line-1">
                            <i class="coop-item-flag"><img :src="item.flag" alt=""></i>
                            <span class="coop-title">{{ item.title }}</span>
                            <span class="coop-subtitle">{{ item.subtitle }}</span>
                            <i class="coop-status"></i>
                        </div>
                        <div class="coop-item-line-2">{{ item.content }}</div>
                    </div>
                </li> -->
                <li class="coop-item" v-for="(item,index) in cooperateList" :key="index">
                    <div class="coop-item-content">
                        <div class="coop-item-line-1">
                            <i class="coop-item-flag"><img :src="coopList[index].flag" alt=""></i>
                            <span class="coop-title">{{ item.title }}</span>
                            <span class="coop-subtitle">{{ item.content }}</span>
                            <i class="coop-status"></i>
                        </div>
                        <div class="coop-item-line-2">{{ item.intro }}</div>
                    </div>
                </li>
            </ul>
        </div>
        <!--开放区域-->
        <!-- <div ref="kfqy" class="open-block">
            <div class="block-title"><img src="@/assets/join/title_Open Areas.png" style="width: 432px;height: auto;margin-bottom: 42px;"alt=""></div>
            <div class="open-block-content">
                <div class="open-block-left">
                    <div class="open-left-line f-red">起于宜春，绽放全国</div>
                    <div class="open-list-top">已开放加盟区域：</div>
                    <ul class="open-list">
                        <li class="open-item" v-for="(item,index) in openAreaList">{{ item }}</li>
                    </ul>
                </div>
                <div class="open-block-right">
                    <img v-show="false" :src="showMapUrl" alt="">
                </div>
            </div>
        </div> -->
        <!--加盟流程-->
        <div ref="jmlc" class="process-block">
            <div class="block-title"><img src="@/assets/join/title_mission.png" style="width: 432px;height: auto;margin-bottom: 63px;" alt=""></div>
            <ul class="process-list">
                <li class="process-item" v-for="(item,index) in processList" :key="index">
                    <div :class="'process-flag process-flag-'+index"></div>
                    <div class="process-text" v-html="item.text"></div>
                </li>
                <li class="process-line"></li>
            </ul>
            <div class="process-t">全程30天 闪速开业，专业团队从选址到开业全程护航</div>
        </div>
        <!--加盟费用-->
        <div ref="jmfy" class="join-fee">
            <div class="join-fee-card" style="height: auto;">
                <!-- <div class="join-fee-top">
                    <span class="fee-weight">加盟费用</span>
                    <span class="fee-normal">约55-60W综合费用</span>
                </div> -->
                <!-- <div style="background: #fff;text-align: center;padding: 12px 0;">
                    <img src="@/assets/join/logo-ip-red.png" style="width: 241px;" alt="">
                </div>
                <div class="join-fee-tabs">
                    <div class="join-fee-tab">非标准门店</div>
                    <div class="join-fee-tab">标准门店（内外仓库需达到经营面积二分之一）</div>
                </div>
                <div class="join-fee-line">
                    <div class="join-fee-block">
                        <div class="join-fee-type">面积要求</div>
                        <div class="join-fee-p">最低150m²</div>
                    </div>
                    <div class="join-fee-block">
                        <div class="join-fee-type">面积要求</div>
                        <div class="join-fee-p">最低180m²</div>
                    </div>
                </div>
                <div class="join-fee-line">
                    <div class="join-fee-block">
                        <div class="join-fee-type">加盟费</div>
                        <div class="join-fee-p">38000元</div>
                    </div>
                    <div class="join-fee-block">
                        <div class="join-fee-type">加盟费</div>
                        <div class="join-fee-p">38000元</div>
                    </div>
                </div>
                <div class="join-fee-line">
                    <div class="join-fee-block">
                        <div class="join-fee-type">保证金</div>
                        <div class="join-fee-p">20000元</div>
                    </div>
                    <div class="join-fee-block">
                        <div class="join-fee-type">保证金</div>
                        <div class="join-fee-p">20000元</div>
                    </div>
                </div>
                <div class="join-fee-line">
                    <div class="join-fee-block">
                        <div class="join-fee-type">管理费</div>
                        <div class="join-fee-p">800元/月</div>
                    </div>
                    <div class="join-fee-block">
                        <div class="join-fee-type">管理费</div>
                        <div class="join-fee-p">800元/月</div>
                    </div>
                </div>

                <div class="join-fee-line">
                    <div class="join-fee-block">
                        <div class="join-fee-type">装修费</div>
                        <div class="join-fee-p">12万元-15万元</div>
                    </div>
                    <div class="join-fee-block">
                        <div class="join-fee-type">装修费</div>
                        <div class="join-fee-p">15万元-19万元</div>
                    </div>
                </div>

                <div class="join-fee-line">
                    <div class="join-fee-block">
                        <div class="join-fee-type">道具设备</div>
                        <div class="join-fee-p">10万元-12万元</div>
                    </div>
                    <div class="join-fee-block">
                        <div class="join-fee-type">道具设备</div>
                        <div class="join-fee-p">10万元-12万元</div>
                    </div>
                </div>

                <div class="join-fee-line">
                    <div class="join-fee-block">
                        <div class="join-fee-type">首次进货</div>
                        <div class="join-fee-p">25万元-30万元</div>
                    </div>
                    <div class="join-fee-block">
                        <div class="join-fee-type">首次进货</div>
                        <div class="join-fee-p">30万元-35万元</div>
                    </div>
                </div> -->

                <!-- <div class="join-fee-line">
                    <div class="join-fee-block">
                        <div class="join-fee-type">加盟费</div>
                        <div class="join-fee-p">38000元</div>
                    </div>
                    <div class="join-fee-block">
                        <div class="join-fee-type">道具/设备</div>
                        <div class="join-fee-p">100000-120000元</div>
                    </div>
                </div>
                <div class="join-fee-line">
                    <div class="join-fee-block">
                        <div class="join-fee-type">保证金</div>
                        <div class="join-fee-p">20000元</div>
                    </div>
                    <div class="join-fee-block">
                        <div class="join-fee-type">装修费用</div>
                        <div class="join-fee-p">120000-150000元</div>
                    </div>
                </div>
                <div class="join-fee-line no-border">
                    <div class="join-fee-block">
                        <div class="join-fee-type">管理费</div>
                        <div class="join-fee-p">800元/月</div>
                    </div>
                    <div class="join-fee-block">
                        <div class="join-fee-type">首次进货</div>
                        <div class="join-fee-p">250,000-300,000元</div>
                    </div>
                </div> -->
            </div>
            <!-- <div class="join-fee-zj">数据仅供参考，具体数据根据本店大小，装修情况等因素差异，与实际情况有所不同，除加盟费、保证金、管理费以及首批货款以外，上图设计服务项目和费用收取均由公司指定第三方完成</div> -->
        </div>
        <!--门店建议-->
        <!-- <div ref="mdjy" class="store-sug">
            <div class="block-title"><img src="@/assets/join/title_suggest.png" style="width: 432px;height: auto;margin-bottom: 42px;" alt=""></div>
            <ul class="sug-list">
                <li class="sug-item">
                    <div class="sug-img"><img src="@/assets/join/icon_suggest_1.png" alt=""></div>
                    <div class="sug-title">商圈人流</div>
                    <div class="sug-entitle">Visitors Flowrate</div>
                    <div class="sub-content">单日人流量<br>不低于5w人次的商圈</div>
                </li>
                <li class="sug-item">
                    <div class="sug-img"><img src="@/assets/join/icon_suggest_2.png" alt=""></div>
                    <div class="sug-title">核心区域</div>
                    <div class="sug-entitle">Core Area</div>
                    <div class="sub-content">商业核心<br>人流制高点</div>
                </li>
                <li class="sug-item">
                    <div class="sug-img"><img src="@/assets/join/icon_suggest_3.png" alt=""></div>
                    <div class="sug-title">门店面积</div>
                    <div class="sug-entitle">Store Area</div>
                    <div class="sub-content">标准门店<br>不低于180㎡ 非标准门店<br>不低于150㎡</div>
                </li>
                <li class="sug-item">
                    <div class="sug-img"><img src="@/assets/join/icon_suggest_4.png" alt=""></div>
                    <div class="sug-title">门头要求</div>
                    <div class="sug-entitle">Door Header</div>
                    <div class="sub-content">门头长度12m以上<br>高度1.5m以上</div>
                </li>
            </ul>
        </div> -->
        <!--常见问答-->
        <div ref="cjwd" class="join-qa">
            <div class="block-title"><img src="@/assets/join/title_Frequently.png" style="width: 432px;height: auto;margin-bottom: 52px;margin-top: 60px;" alt=""></div>
            <ul class="qa-list">
                <li :class="{'qa-item':true,'active-qa':item.status === 'open'}" v-for="(item,index) in qaList" :key="index" @click="toggleQAStatus(item)">
                    <div class="qa-q">
                        <span><span :class="{ 'f-red':item.status === 'close' }">Q{{ index+1 }}：</span>{{ item.title }}</span>
                        <i class="opt-qa open-qa"><img src="@/assets/join/button_open.png" alt=""></i>
                        <i class="opt-qa close-qa"><img src="@/assets/join/button_pack.png" alt=""></i>
                    </div>
                    <div class="qa-a">
                        <span class="f-red f-wei">A{{ index+1 }}：</span>
                        <span>{{ item.content }}</span>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</template>
<script>
    export default {
        data(){
            return {
                coopList:[
                    {flag:require('@/assets/join/icon_Cooperation_1.png'),title:'选址支持',subtitle:'协助选址，精确找铺',content:'拓展专员在每个区域都会根据当地的人口和商业业态进行规划，并为加盟商提供专业的找店建议和选址指导。'},
                    {flag:require('@/assets/join/icon_Cooperation_2.png'),title:'严格选品',subtitle:'不入我口，不进我店',content:'赵一鸣拥有严格选品团队，本着不入我口，不进我店的原则，优选行业TOP3厂家正品直采。'},
                    {flag:require('@/assets/join/icon_Cooperation_3.png'),title:'品控把关',subtitle:'线上巡检+线下稽查',content:'严格参照食品安全法规，健全采购、运输，存储等各环节的品控流程，线上巡检+线下稽查结合为门店经营严格把关。'},
                    {flag:require('@/assets/join/icon_Cooperation_4.png'),title:'品牌营销',subtitle:'多方位品牌引流',content:'焕然一新的品牌VI和活力元气的IP人物小鸣，让鸣鸣很忙旗下品牌的形象具有鲜明的辨识度;同时邀请国民优秀艺人周杰伦成为零食很忙&赵一鸣零食双品牌代言人，并通过多样化的品牌营销活动，大大地提升了品牌知名度和美誉度。'},
                    {flag:require('@/assets/join/icon_Cooperation_5.png'),title:'物流支持',subtitle:'全国36大智能仓配中心',content:'在集团的支持下，我们战略性地建立了全国性仓储网络。基于门店网络布局了36个仓，总占地面积超70万㎡，保障品牌全国门店报货24小时必达，打造行业领先的智能物流运营体系。'},
                    {flag:require('@/assets/join/icon_Cooperation_6.png'),title:'统一装修',subtitle:'定制设计·专业施工团队',content:'设计师根据门店销售及商品为门店定制设计图纸，标准VIS支持，统一风格装修，让顾客享受舒适购物环境。'},
                    {flag:require('@/assets/join/icon_Cooperation_7.png'),title:'陈列指导',subtitle:'科学的陈列指导',content:'更科学的陈列，经过近千家门店验证，不仅增强购物体验，也让销售额得到提升。'},
                    {flag:require('@/assets/join/icon_Cooperation_8.png'),title:'人员培训',subtitle:'免费员工培训',content:'培训老师会在门店开业前安排门店员工培训，为期十天，培训完需要考核通过后方可上岗。'},
                    {flag:require('@/assets/join/icon_Cooperation_9.png'),title:'全程指导',subtitle:'专业团队指导开业',content:'开业阶段:公司指派专业运营专员对新开门店进行开业指导，协助新门店举办开业庆典，帮助门店尽快熟悉运营流程。'},
                    {flag:require('@/assets/join/icon_Cooperation_10.png'),title:'售后支持',subtitle:'完整的售后体制',content:'公司建设行业内完善的售后体制，协助门店妥善解决售后问题，给予门店强有力的售后保障。'}
                ],
                cooperateList:[],
                processList:[
                    {flag:require('@/assets/join/icon_join_1.png'),text:'填写<br>加盟申请表'},
                    {flag:require('@/assets/join/icon_join_2.png'),text:'电话初审通过<br>预约招商会'},
                    {flag:require('@/assets/join/icon_join_3.png'),text:'参加招商会<br>及一次面谈'},
                    {flag:require('@/assets/join/icon_join_4.png'),text:'走访市场<br>并提交背调问卷'},
                    {flag:require('@/assets/join/icon_join_5.png'),text:'参加二次面谈<br>通过后确定意向区域'},
                    {flag:require('@/assets/join/icon_join_6.png'),text:'签订意向协议<br>对接开发专员选址找店'},
                    {flag:require('@/assets/join/icon_join_7.png'),text:'店面审核通过<br>签订合作合同'},
                ],
                qaList:[
                    {title:'投资赵一鸣多少时间可以回本？',content:'任何投资都有一定的风险，请阁下谨慎投资。门店的利润是由多方面的因素所决定，人为疏失都会导致利润的下降，公司无法保证任何门店的回本时间。',status:'open'},
                    {title:'赵一鸣的加盟要求为什么这么高？',content:'目前国内的休闲食品行业开始稳健发展，整个行业在未来的几年内还会有巨大的发展。在这个行业发展较为成熟的区域，同行业竞争非常激烈，提高门店整体实力是在竞争中制胜的关键因素。赵一鸣从开始就定位为一个坚持让利消费者的连锁品牌，不会为了追求短期的利润而去盲目扩张。',status:'close'},
                    {title:'我有一个70平方米的店面，可以加盟吗？',content:'为了保证投资的成功，公司对店面的审核要求非常严格。门店选址具体要求为：不低于5万人流量的商圈，商业街或购物中心内；工程条件：标准门店店铺面积不低于180㎡，招牌尺寸：长度12m以上，高度1.5m以上；非标准门店店铺面积不低于150㎡，门店宽度不低于12米，转角店面优先。',status:'close'},
                    {title:'我已具备以上条件了，如何联系你们？',content:'请阁下拨打招商服务热线 400-070-2717 咨询具体合作事宜，非工作时段添加微信 17346755177 进行咨询。',status:'close'},
                ],
                areaList1:[
                    {name:'江西省',url:require('@/assets/join/map_jiangxi.png')},
                    {name:'广东省',url:require('@/assets/join/map_guangdong.png')},
                    // {name:'重庆市',url:require('@/assets/join/map_chongqing.png')},
                    {name:'浙江省',url:require('@/assets/join/map_chongqing.png')},
                    {name:'山西省',url:require('@/assets/join/map_shanxi.png')},
                    {name:'山东省',url:require('@/assets/join/map_shandong.png')},

                ],
                areaList3:[
                    {name:'天津市',url:require('@/assets/join/map_tianjin.png')},
                    {name:'海南省',url:require('@/assets/join/map_hainan.png')},
                    // {name:'湖南省',url:require('@/assets/join/map_hunan.png')},
                    {name:'福建省',url:require('@/assets/join/map_fujian.png')},
                    // {name:'湖北省',url:require('@/assets/join/map_hubei.png')},
                    {name:'广西壮族自治区',url:require('@/assets/join/map_guangxi.png')}

                ],
                areaList2:[
                    {name:'安徽省',url:require('@/assets/join/map_anhui.png')},
                    {name:'江苏省',url:require('@/assets/join/map_jiangsu.png')},
                    {name:'河南省',url:require('@/assets/join/map_henan.png')},
                    {name:'河北省',url:require('@/assets/join/map_hebei.png')},
                    {name:'陕西省',url:require('@/assets/join/map_shanxi2.png')}
                    
                ],
                areaList4:[
                    // {name:'四川省',url:require('@/assets/join/map_sichuan.png')},
                    // {name:'广西壮族自治区',url:require('@/assets/join/map_guangxi.png')},
                ],
                openAreaList:[],
                showMapUrl:require('@/assets/join/map.png'),
                countObj:{
                    successRate:95,
                    secondRate:67,
                    storeNum:2200,
                    customerNum:1.5
                }
            }
        },
        mounted(){
            this.getData();
            this.linkPos();
            this.getCooperateList();
            this.getOpenArea();
        },
        watch:{
            $route(to,from){
                if(to.query.block){
                    this.linkPos();
                }
            }
        },
        methods:{
            getData(){
                const url = this.$WEBSITE_URL_OBJECT.osconfig;
                this.$axios.get(url).then(res=>{
                    const {data} = res.data;
                    if(res.data.code === 0){
                        this.countObj = {
                            successRate:data.successPercent,
                            secondRate:67, //data.secondPercent,
                            storeNum:data.storeNum,
                            customerNum:data.customerNum
                        }
                    }else{
                        this.countObj = {
                            successRate:95,
                            secondRate:67,
                            storeNum:2200,
                            customerNum:1.5
                        }
                    }
                }).catch(()=>{
                    this.countObj = {
                        successRate:95,
                        secondRate:67,
                        storeNum:2200,
                        customerNum:1.5
                    }
                }).finally(()=>{

                })
            },
            toggleQAStatus(item){
                item.status = item.status === 'open' ? 'close' : 'open';
            },
            showMap(url){
                this.showMapUrl = url;
            },
            linkPos(){
                const route = this.$route;
                const ref = route.query.block;
                if(ref){
                    const el = this.$refs[ref]
                    el.scrollIntoView(); 
                }
            },
            getCooperateList(){
                let url = this.$WEBSITE_URL_OBJECT.getCooperateList;
                this.$axios.get(url).then(res=>{
                    if(res.data.code === 0){
                        this.cooperateList = res.data.data
                        this.cooperateList[4].intro = '在集团的支持下，我们战略性地建立了全国性仓储网络。基于门店网络布局了36个仓，总占地面积超70万㎡，保障品牌全国门店报货24小时必达，打造行业领先的智能物流运营体系。'
                        this.cooperateList[4].content = '全国36大智能仓配中心'
                        this.cooperateList[3].intro = '焕然一新的品牌VI和活力元气的IP人物小鸣，让鸣鸣很忙旗下品牌的形象具有鲜明的辨识度;同时邀请国民优秀艺人周杰伦成为零食很忙&赵一鸣零食双品牌代言人，并通过多样化的品牌营销活动，大大地提升了品牌知名度和美誉度。'

                console.log(this.cooperateList, 'this.cooperateList');

                    }else{
                        this.cooperateList = [];
                    }
                }).catch(()=>{
                    this.cooperateList = [];
                })
                

            },
            getOpenArea(){
                let url = this.$WEBSITE_URL_OBJECT.getOpenArea;
                this.$axios.get(url).then(res=>{
                    if(res.data.code === 0){
                        this.openAreaList = res.data.data
                    }else{
                        this.openAreaList = [];
                    }
                }).catch(()=>{
                    this.openAreaList = [];
                })
            }
        }
    }
</script>
<style scoped >
@media screen and (max-width: 1800px) {
    .coop-item{
        height: 100px!important;
    }
    .coop-item:hover .coop-item-content{
        height: 272px!important;
    }
    .coop-item-content{
        min-height: 100px!important;
    }
    .coop-item-line-1{
        padding: 20px 40px!important;
    }
    .coop-title{
        font-size: 30px!important;
        line-height: 30px!important;
    }
    .coop-subtitle{
        font-size: 24px!important;
    }
    .coop-item-line-2{
        font-size: 28px!important;
        line-height: 40px!important;
    }
    .coop-status{
        top: 28px!important;
    }
    .process-list{
        font-size: 18px!important;
    }
    .process-t{
        font-size: 40px!important;
    }
    .open-left-line{
        font-size: 40px!important;
    }
    .open-block-content{
        padding: 0 70px!important;
    }
    .open-item{
        font-size: 24px!important;
        line-height: 30px!important;
    }
    .open-block-right img{
        width: 600px;
        height: auto;
    }
}
.container{
    min-width: 1400px;
    font-family: Source Han Sans;
}
.content-banner{
    position: relative;
}
.content-banner::before{
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0,0,0,.4);
}
.content-banner img{
    display: block;
    width: 100%;
    height: auto;
}
/*十大合作支持*/
.content-block-1{
    position: relative;
    padding:140px 160px 0;
    background: linear-gradient(#FF9CA4,#fff);
}
.top-container{
    position: absolute;
    top: -120px;
    left: 0;
    width: 100%;
}
.top-card{
    margin:0 auto;
    width: 1350px;
    padding: 47px 0;
    display: flex;
    justify-content: space-between;
    border-radius: 74px;
    background-color: #fff;
}
.top-card-item{
    flex: 1;
    font-size: 54px;
    /* font-family: Source Han Sans CN-Regular, Source Han Sans CN; */
    font-weight: 400;
    color: #000000;
    line-height: 70px;
    text-align: center;
}
.f-red{
    color: #E60012!important;
    
}
.f-wei{
    font-weight: 700;
}

.coop-content img{
    display: block;
    height: auto;
}
.coop-list{
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
}
.coop-item{
    width: calc(50% - 18px);
    height: 152px;
    margin-bottom: 36px;
    overflow: visible;
}
.coop-item-content{
    min-height: 152px;
    background: linear-gradient(#ffe0e3,#fff);
    border-radius: 36px;
}
.coop-item-line-1{
    position: relative;
    padding: 40px 50px 40px;
    display: flex;
    align-items: center;
}
.coop-item-flag{
    width: 64px;
    height: 64px;
}
.coop-item-flag img{
    display: block;
    text-align: center;
    line-height: 64px;
}
.coop-title{
    padding-left: 30px;
    font-size: 54px;
    /* font-family: Source Han Sans CN-Bold, Source Han Sans CN; */
    font-weight: bold;
    color: #590D0D;
    line-height: 54px;
}
.coop-subtitle{
    padding-left: 12px;
    font-size: 32px;
    /* font-family: Source Han Sans CN-Normal, Source Han Sans CN; */
    font-weight: 400;
    color: #E60012;
    line-height: 32px;
}
.coop-status{
    width: 40px;
    height: 40px;
    position: absolute;
    top: 54px;
    right: 30px;
    background: url(../../assets/join/button_pack2.png) center no-repeat;
    transform: rotate(180deg);
}
.coop-status:hover{
    cursor: pointer;
}
.active-coop .coop-status{
    background: url(../../assets/join/button_open2.png) center no-repeat;
}
.coop-item-line-2{
    display: none;
    padding: 0 34px 10px 44px;
    font-size: 32px;
    /* font-family: Source Han Sans CN-Normal, Source Han Sans CN; */
    font-weight: 400;
    color: #000000;
    line-height: 51px;
}
.coop-item:hover{
    cursor: pointer;
    z-index: 2;
}
.coop-item:hover .coop-item-content{
    height: 354px;
}
.coop-item:hover .coop-status{
    background: url(../../assets/join/button_open2.png) center no-repeat;
}
.coop-item:hover .coop-item-line-2{
    display: block!important;
}
/*开放区域*/
.open-block{
    padding: 90px 0;
    background: linear-gradient(#fff 0%,#fff 88%,#FBD6D9 95%);
}
.block-title{
    text-align: center;
}
.open-block-content{
    display: flex;
    padding: 0 140px;
}
.open-block-left{
    width: 890px;
}
.open-left-line{
    font-size: 54px;
    /* font-family: Source Han Sans CN-Bold, Source Han Sans CN; */
    font-weight: bold;
    color: #000;
    line-height: 81px;
}
.open-list-top{
    padding-top: 30px;
    font-size: 32px;
    /* font-family: Source Han Sans CN-Bold, Source Han Sans CN; */
    font-weight: bold;
    color: #000000;
    line-height: 48px;
}
.open-list{
    display: flex;
    flex-wrap: wrap;
    margin-left: -20px;
}
.open-item{
    padding: 12px 10px 12px 50px;
    background: url(../../assets/join/icon_piont.png) 0 center no-repeat;
    background-size: 62px auto;
    font-size: 32px;
    /* font-family: Source Han Sans CN-Medium, Source Han Sans CN; */
    font-weight: 500;
    color: #000000;
    line-height: 48px;
}
.open-item:hover{
    cursor: pointer;
    background: url(../../assets/join/icon_piont_C.png) 0 center no-repeat;
    background-size: 62px auto;
}
/*加盟流程*/
.process-block{
    padding: 70px 160px 0;
    background: linear-gradient(#FBD6D9,#E60012);
}
.process-list{
    position: relative;
    display: flex;
    justify-content: space-between;
    font-size: 24px;
    /* font-family: Source Han Sans CN-Regular, Source Han Sans CN; */
    font-weight: 400;
    color: #FFFFFF;
    line-height: 35px;
    text-align: center;
}
.process-line{
    position: absolute;
    top: 70px;
    left: 10%;
    width: 80%;
    height: 5px;
    background-color: #fdd;
    z-index: 1;
}
.process-item{
    flex: 1;
    z-index: 2;
}
.process-item:hover{
    cursor: pointer;
}
.process-item:hover .process-flag{
    border: 4px solid #fff;
}
.process-flag{
    display: flex;
    align-items: center;
    margin: 0 auto;
    width: 136px;
    height: 136px;
    line-height: 136px;
    border-radius: 50%;
    background: url(../../assets/join/icon_join_1.png) center no-repeat,linear-gradient(180deg, #FFFFFF 0%, #FFBBBB 100%);
}
.process-flag-0{
    background: url(../../assets/join/icon_join_1.png) center no-repeat,linear-gradient(180deg, #FFFFFF 0%, #FFBBBB 100%);
}
.process-flag-1{
    background: url(../../assets/join/icon_join_2.png) center no-repeat,linear-gradient(180deg, #FFFFFF 0%, #FFBBBB 100%);
}
.process-flag-2{
    background: url(../../assets/join/icon_join_3.png) center no-repeat,linear-gradient(180deg, #FFFFFF 0%, #FFBBBB 100%);
}
.process-flag-3{
    background: url(../../assets/join/icon_join_4.png) center no-repeat,linear-gradient(180deg, #FFFFFF 0%, #FFBBBB 100%);
}
.process-flag-4{
    background: url(../../assets/join/icon_join_5.png) center no-repeat,linear-gradient(180deg, #FFFFFF 0%, #FFBBBB 100%);
}
.process-flag-5{
    background: url(../../assets/join/icon_join_6.png) center no-repeat,linear-gradient(180deg, #FFFFFF 0%, #FFBBBB 100%);
}
.process-flag-6{
    background: url(../../assets/join/icon_join_7.png) center no-repeat,linear-gradient(180deg, #FFFFFF 0%, #FFBBBB 100%);
}

.process-item:hover .process-flag-0{
    background: url(../../assets/join/icon_join_1_w.png) center no-repeat,linear-gradient(#E60012);
}
.process-item:hover .process-flag-1{
    background: url(../../assets/join/icon_join_2_w.png) center no-repeat,linear-gradient(#E60012);
}
.process-item:hover .process-flag-2{
    background: url(../../assets/join/icon_join_3_w.png) center no-repeat,linear-gradient(#E60012);
}
.process-item:hover .process-flag-3{
    background: url(../../assets/join/icon_join_4_w.png) center no-repeat,linear-gradient(#E60012);
}
.process-item:hover .process-flag-4{
    background: url(../../assets/join/icon_join_5_w.png) center no-repeat,linear-gradient(#E60012);
}
.process-item:hover .process-flag-5{
    background: url(../../assets/join/icon_join_6_w.png) center no-repeat,linear-gradient(#E60012);
}
.process-item:hover .process-flag-6{
    background: url(../../assets/join/icon_join_7_w.png) center no-repeat,linear-gradient(#E60012);
}

.process-flag img{
    display: block;
    margin: 0 auto;
}
.process-text{
    padding-top: 20px;
}
.process-t{
    padding: 60px 0 40px;
    text-align: center;
    font-size: 54px;
    /* font-family: Source Han Sans CN-Regular, Source Han Sans CN; */
    font-weight: 400;
    color: #FFFFFF;
    line-height: 86px;
}
/*加盟费用*/
.join-fee{
    padding: 0 160px;
    background: linear-gradient(#E60012,#F8B5BA);
}
.join-fee-card{
    max-width: 1600px;
    margin: 0 auto;
    /* height: 650px; */
    /* background:#FFDBDE  url(../../assets/join/bg_card_statement.png) 0 0 no-repeat; */
    background-size: 100% auto;
    background: #fff;
    border-radius: 76px;
    overflow: hidden;
}
.join-fee-top{
    padding: 40px 80px 10px;
}
.fee-weight{
    font-size: 104px;
    /* font-family: Source Han Sans CN-Bold, Source Han Sans CN; */
    font-weight: bold;
    color: #E60012;
    line-height: 156px;
}
.fee-normal{
    padding-left: 20px;
    font-size: 54px;
    /* font-family: Source Han Sans CN-Regular, Source Han Sans CN; */
    font-weight: 400;
    color: #000000;
    line-height: 81px;
}
.join-fee-tabs{
    display: flex;
}
.join-fee-tab{
    padding: 25px 0;
    flex: 1;
    text-align: center;
    font-size: 32px;
    /* font-family: Source Han Sans CN-Bold, Source Han Sans CN; */
    font-weight: bold;
    color: #FFFFFF;
    line-height: 48px;
    background: linear-gradient(90deg, #E60012 0%, #FF7580 100%);
}
.join-fee-line{
    display: flex;
}
.join-fee-block{
    flex: 1;
    display: flex;
    border-bottom: 2px solid #FFC9CD;
}

.join-fee-type{
    width: 40%;
    padding: 16px 0;
    text-align: center;
    font-size: 32px;
    /* font-family: Source Han Sans CN-Bold, Source Han Sans CN; */
    font-weight: bold;
    color: #E60012;
    background: #FFD8DB;
}
.join-fee-p{
    width: 60%;
    padding: 16px 0;
    text-align: center;
    font-size: 32px;
    /* font-family: Source Han Sans CN-Heavy, Source Han Sans CN; */
    font-weight: 800;
    color: #000000;
    line-height: 48px;
    background-color: #fff;
}
.no-border{
    border:none!important;
}
.join-fee-zj{
    padding: 30px 40px;
    font-size: 32px;
    /* font-family: Source Han Sans CN-Normal, Source Han Sans CN; */
    font-weight: 400;
    color: #FFFFFF;
    line-height: 48px;
}
/*门店建议*/
.store-sug{
    padding: 30px 120px 0;
    background: linear-gradient(#F8B5BA,#fff 50%);
}
.sug-list{
    max-width: 1600px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    text-align: center;
}
.sug-item{
    width: 25%;
}
.sug-item:hover{
    cursor: pointer;
    background: linear-gradient(180deg, rgba(230,0,18,0.1) 0%, rgba(230,0,18,0) 100%);
    border-radius: 76px 76px 0 0;
}
.sug-img{
    width: 160px;
    height: 160px;
    margin: 0 auto;
}
.sug-img img{
    display: block;
    width: 100%;
    height: 100%;
}
.sug-title{
    font-size: 54px;
    /* font-family: Source Han Sans CN-Bold, Source Han Sans CN; */
    font-weight: bold;
    color: #E60012;
    line-height: 81px
}
.sug-entitle{
    font-size: 24px;
    /* font-family: Source Han Sans CN-Regular, Source Han Sans CN; */
    font-weight: 400;
    color: rgba(230, 0, 18,.2);
    line-height: 36px;
}
.sub-content{
    font-size: 32px;
    /* font-family: Source Han Sans CN-Normal, Source Han Sans CN; */
    font-weight: 400;
    color: #000000;
    line-height: 45px;
}
/*常见问答*/
.join-qa{
    padding:  70px 160px 80px;
}
.qa-item{
    padding-bottom: 20px;
}
.qa-item:hover{
    cursor: pointer;
}
.qa-q{
    position: relative;
    padding: 25px 66px;
    font-size: 32px;
    /* font-family: Source Han Sans CN-Bold, Source Han Sans CN; */
    font-weight: bold;
    color: #000;
    line-height: 45px;
    background: linear-gradient(180deg, #FCE3E5 0%, #FFEDEF 100%);
    border-radius: 76px;
}
.active-qa .qa-q{
    background: linear-gradient(180deg, #E60012 0%, #FF7580 100%);
    color: #fff;
}
.opt-qa{
    position: absolute;
    top: 0;
    right: 0;
    width: 38px;
    height: 38px;
    top: 50%;
    right: 40px;
    margin: -19px 0;
}
.active-qa .open-qa{
    display: none;
}
.close-qa{
    display: none;
}
.active-qa .close-qa{
    display: block;
}
.opt-qa img{
    display: block;
    width: 100%;
    height: 100%;
}
.active-qa .qa-a{
    padding: 32px 66px;
    height: auto;
    transition: all .5s ease;
}
.qa-a{
    height: 0;
    font-size: 32px;
    /* font-family: Source Han Sans CN-Normal, Source Han Sans CN; */
    font-weight: 400;
    color: #000000;
    line-height: 51px;
    overflow: hidden;
    transition: all .5s ease;
}
.bottom-logo{
    padding-bottom: 20px;
    text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/view/join/index.vue